module.exports = __webpack_public_path__ + "media/packs/images/flags/SG-82fc976409bf57503d424e5809f9add5.svg";